export const CODE = 'code';
export const TOKEN = 'token';
export const DEBUG = 'debug';
export const STATE = 'state';
export const SCOPES = 'scopes';
export const SESSION = 'session';
export const TEMP_SESSION = 'temp-session';
export const TARGET_ROUTE = 'target-route';
